import * as React from "react";
import { Initialize } from "@warda/library-ui/interfaces";
import Text from "@warda/library-ui/core/Text";
import { getTheme } from "@warda/library-ui/theme";
import { FilterWrapper, FilterSelect, } from "@warda/library-ui/core/Filter";
import { MISSING_KEY } from "@warda/library-ui/constants";
import inLoading from "@warda/library-ui/utils/inLoading";
import reducer, { reducerInitState, ACTION } from "./reducer";
import { filterDictionaries } from "../../../api/fetchesApiProducts";
import { ATT_NO_LANG_ID } from "../../AreaProducts/PanelDetail/constants";
import { FilterTypeSingleSelection } from "../utils";
import { useContextAggrType } from "../../Main";
const getItemLabel = (dictValue, langId) => dictValue[langId] || dictValue[ATT_NO_LANG_ID];
const FilterSearchDictionaries = (p) => {
    const aggregateType = useContextAggrType().value;
    const { id, label, labelSub, type, value = [], onChange, onClickCount, className, collapsed, collapsedHelp, column, slcCtlg, slcLang, mandatory, } = p;
    const [state, dispatch] = React.useReducer(reducer, reducerInitState);
    const { initialize, error, optionsInput, optionsItems, optionsTotal } = state;
    const { editField, multiCatalog } = column;
    const onSearch = React.useCallback((input) => {
        dispatch({ type: ACTION.SEARCH, input });
    }, []);
    const options = optionsItems
        .map(({ id, label, dictCode, dictValue }) => {
        if (id === MISSING_KEY)
            return { id, label };
        const item = {
            id: dictCode,
            label: getItemLabel(dictValue, slcLang),
            subLabel: dictCode,
        };
        return item;
    })
        .sort((a, b) => {
        if (a.label > b.label)
            return 1;
        if (a.label < b.label)
            return -1;
        return 0;
    });
    React.useEffect(() => {
        (async () => {
            if (initialize === Initialize.START) {
                dispatch({ type: ACTION.INIT_WAIT });
                try {
                    if (!editField)
                        throw `Filter config without "editField"`;
                    const { dictionaryId, dictionaryType } = editField;
                    const { items, total } = await filterDictionaries({
                        dictionaryId,
                        dictionaryType,
                        searchableValue: optionsInput,
                        catalog: multiCatalog ? slcCtlg : undefined,
                        aggregateType,
                    });
                    const itemsDict = items.map((d) => ({
                        id: d.id,
                        label: "xxx",
                        dictCode: d.code,
                        dictValue: d.value,
                        dictCatalog: d.catalog,
                    }));
                    itemsDict.splice(0, 0, {
                        id: MISSING_KEY,
                        label: "No value",
                        dictCode: undefined,
                        dictValue: undefined,
                        dictCatalog: undefined,
                    });
                    dispatch({ type: ACTION.INIT_SUCC, items: itemsDict, total });
                }
                catch (err) {
                    dispatch({ type: ACTION.INIT_FAIL, error: err });
                }
            }
        })();
    }, [
        aggregateType,
        editField,
        initialize,
        multiCatalog,
        optionsInput,
        slcCtlg,
    ]);
    if (error) {
        return (React.createElement(FilterWrapper, { key: id, label: label, color: getTheme().colors.theme1 },
            React.createElement(Text, { style: {
                    marginLeft: 15,
                    color: getTheme().colors.disable,
                }, children: error })));
    }
    return (React.createElement(FilterSelect, { id: id, type: type, label: label, labelSub: labelSub, onChange: onChange, onClickCount: onClickCount, options: options, value: value.map((v) => v.id), maxItems: type === FilterTypeSingleSelection ? 1 : undefined, className: className, collapsed: collapsed, collapsedHelp: collapsedHelp, mandatory: mandatory, searchable: true, onSearch: onSearch, optionsMore: optionsTotal - options.length, loadingSearch: inLoading(initialize) }));
};
export default FilterSearchDictionaries;
